import React, { useState } from 'react';
import api from '../lib/api';
import { useAuth } from '../context/AuthContext';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../components/ui/dialog';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Button } from '../components/ui/button';
import { toast } from 'sonner';
import { Lock } from 'lucide-react';

const ForceChangePassword = () => {
  const { mustChangePassword, completePasswordChange } = useAuth();
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);

  if (!mustChangePassword) return null;

  const handleSubmit = async () => {
    if (newPassword.length < 6) { toast.error('Password must be at least 6 characters'); return; }
    if (newPassword !== confirmPassword) { toast.error('Passwords do not match'); return; }
    setSubmitting(true);
    try {
      await api.post('/auth/change-password', { new_password: newPassword });
      toast.success('Password changed successfully');
      completePasswordChange();
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Failed to change password');
    } finally { setSubmitting(false); }
  };

  return (
    <Dialog open={true}>
      <DialogContent className="max-w-sm [&>button]:hidden" onInteractOutside={(e) => e.preventDefault()}>
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Lock className="w-5 h-5 text-[#B89B72]" />
            Set Your New Password
          </DialogTitle>
        </DialogHeader>
        <p className="text-sm text-slate-500 mt-1">Your password has been reset by an administrator. Please create a new password to continue.</p>
        <div className="space-y-4 mt-3">
          <div>
            <Label>New Password</Label>
            <Input type="password" value={newPassword} onChange={e => setNewPassword(e.target.value)} placeholder="Minimum 6 characters" className="mt-1" data-testid="new-password-input" />
          </div>
          <div>
            <Label>Confirm Password</Label>
            <Input type="password" value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} placeholder="Re-enter password" className="mt-1" data-testid="confirm-password-input" onKeyDown={e => e.key === 'Enter' && handleSubmit()} />
          </div>
          <Button className="w-full bg-slate-900 hover:bg-slate-800" onClick={handleSubmit} disabled={submitting} data-testid="change-password-submit">
            {submitting ? 'Saving...' : 'Set Password & Continue'}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ForceChangePassword;
